import {defineQuery} from 'next-sanity';

export const ARTICLE_PAGE_SIZE = 10;

export const ARTICLE_SEARCH_QUERY = defineQuery(`
*[_type == "article"]
	| order(coalesce(publishDate, _createdAt) desc, _id desc)
	[0...${ARTICLE_PAGE_SIZE}] {
	...,
	"category": {
		"title": category->title,
		"slug": category->slug
	},
	"totalArticles": count(*[_type == "article"])
}
`);

// Visitor-supplied filter values must only ever reach these queries as params,
// never interpolated. An empty $categoryFilters or $searchQuery disables that filter.
// The list and count queries share this filter so that they cannot drift apart.
const ARTICLE_DYNAMIC_SEARCH_FILTER = `_type == "article"
	&& (count($categoryFilters) == 0 || category->slug.current in $categoryFilters)
	&& ($searchQuery == "" || title match $searchQuery || heading[0] match $searchQuery)`;

export const ARTICLE_DYNAMIC_SEARCH_QUERY = defineQuery(`
*[
	${ARTICLE_DYNAMIC_SEARCH_FILTER}
]
	| order(coalesce(publishDate, _createdAt) desc, _id desc)
	[$start...$end] {
	...,
	"category": {
		"title": category->title,
		"slug": category->slug
	}
}
`);

export const ARTICLE_DYNAMIC_SEARCH_COUNT_QUERY = defineQuery(`
count(*[
	${ARTICLE_DYNAMIC_SEARCH_FILTER}
])
`);

export const TOTAL_ARTICLES_QUERY = defineQuery(`
	count(*[_type == "article" && defined(slug.current)])
`);
